export default "__VITE_ASSET__C8gobv3O__"